import React from 'react';
import '../styles/LevelLadder.scss';
import { LEVEL_COLOURS } from '../config/theme';

const NC = 'Non-Compliant';
const short = (label) => (label === NC ? 'NC' : label.replace('Level ', 'L'));

// Steps come straight from the backend thresholds (highest first); we only sort them.
// "Your level" is the backend's final level (after discounting and YES).
// "Points alone" marks the level the points reach on their own, when different.
const LevelLadder = ({ beeLevel }) => {
  if (!beeLevel?.thresholds?.length) return null;
  const { combined_points: points, level, thresholds } = beeLevel;
  const steps = [{ min: 0, label: NC }, ...[...thresholds].sort((a, b) => a.min - b.min)];
  const pointsLevel = [...steps].reverse().find((s) => points >= s.min)?.label ?? NC;

  return (
    <div className="ladder" role="img" aria-label={`B-BBEE level ladder. Your level: ${level}.`}>
      <div className="ladder-steps">
        {steps.map((s, i) => {
          const isHere = s.label === level;
          const isPoints = s.label === pointsLevel && pointsLevel !== level;
          const cls = ['ladder-step', points >= s.min && 'is-reached', isPoints && 'is-points', isHere && 'is-here']
            .filter(Boolean).join(' ');
          return (
            <div
              key={s.label}
              className={cls}
              style={{ height: `${18 + (i * 82) / (steps.length - 1)}%`, '--lv': LEVEL_COLOURS[s.label] }}
            >
              {isHere && <span className="ladder-pin">Your level</span>}
              {isPoints && <span className="ladder-pin ladder-pin--muted">Points alone</span>}
              <span className="ladder-lv">{short(s.label)}</span>
              <span className="ladder-min">{s.min}+</span>
            </div>
          );
        })}
      </div>
      <div className="ladder-key"><span>Non-compliant</span><span>Level 1</span></div>
    </div>
  );
};

export default LevelLadder;
